import { selectSuggestedProduct } from 'swag-client-common/redux/cart/cart.actions';
export const suggestedProductListDispatcher = dispatch => ({
  onSuggestedProductClick: product => {
    dispatch(selectSuggestedProduct(product));
  }
});